import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Product Changelog Software and Release Notes Tool | Canny';
const Description =
  'Share product updates with your users with our product changelog software and release note tools. Get started for free and set up in minutes.';
const Image = 'https://canny.io/images/canny-changelog-helmet.jpg';
const ProductChangelogUrl = 'https://canny.io/features/product-changelog';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${ProductChangelogUrl}#webpage`,
    url: ProductChangelogUrl,
    name: 'Product Changelog - Canny',
    description:
      "Announce product updates, share new features, and keep customers engaged with Canny's Product Changelog feature.",
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${ProductChangelogUrl}#capabilities`,
    'Product Changelog Capabilities',
    [
      {
        name: 'Publish Product Updates',
        description: 'Announce new features and improvements with clear, engaging release notes.',
      },
      {
        name: 'Engage Users with Announcements',
        description:
          'Keep customers informed and engaged by sharing updates directly within your product.',
      },
      {
        name: 'Organize Release Notes',
        description:
          'Maintain an organized, searchable changelog for users to reference past updates.',
      },
      {
        name: 'Integrate with Feedback',
        description:
          "Connect product updates to customer feedback to close the loop and show users you're listening.",
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Features', item: 'https://canny.io/features' },
    { name: 'Product Changelog', item: ProductChangelogUrl },
  ]),
]);

export default class LandingChangelogHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: ProductChangelogUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
